module.exports = __webpack_public_path__ + "img/Airbnb-Equipmnet-Lighting-1.2191f805.jpg";